<template>
  <div v-if="loading" id="loading" :class="pageType=='app'?'loading_app':''">
    <div v-if="pageType=='app'"><img src="@/assets/images/template/loading.gif"></div>
    <div v-else>
      <img src="@/assets/images/template/loading.gif">
      <span>{{ text }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Loading',
  data() {
    return {
      loading: false,
      text: '数据正在加载中...'
    }
  },
  computed: {
    ...mapState(['pageType'])
  },
  created() {
    this.$bus.$on('loading', (data, text) => {
      this.loading = !data
      if (text != null && text != '') this.text = text
      else this.text = '数据正在加载中...'
    })
  },
  beforeDestroy() {
    this.$bus.$off('loading', (data, text) => {
      this.loading = data
      if (text != null && text != '') this.text = text
      else this.text = '数据正在加载中...'
    })
  }
}
</script>
